import { Builder, BuilderBlocks } from "@builder.io/react/lite";
import { Container, Row, Col } from '../../components/grid';

const defaultBlocks = [
    {
        '@type': '@builder.io/sdk:Element',
        component: {
            name: 'Dummy'
        },
    },
];

export const FullRowGrid = (props) => {
    if (props.firstblock.length > 0 && props.firstblock[0].component.name === "Dummy") {
        props.firstblock.shift();
    }
    return (< Container xl margins g-xs={2}>
        <Row>
            <Col md={12}>
                <BuilderBlocks
                    child
                    blocks={props.firstblock}
                    parentElementId={props.builderBlock && props.builderBlock.id}
                    dataPath={`component.options.firstblock`}
                />
            </Col>
        </Row>
    </Container >)
};

Builder.registerComponent(FullRowGrid, {
    name: "FullRowGrid",
    static: true,
    inputs: [
        {
            name: 'firstblock',
            type: 'uiBlocks',
            hideFromUI: false,
            defaultValue: defaultBlocks
        }
    ],
});